import { ROLES } from "../constants/roles.js";

export interface UserContext {
  role: string;
  sites: string[];
}

// Ported from canRead/canWrite/canModify/isAdmin (source lines 2469-2498).
function checkPerm(user: UserContext | null | undefined, siteCode: string | undefined, level: "read" | "write" | "modify"): boolean {
  if (!user) return false;
  const role = ROLES[user.role];
  if (!role) return false;
  const perm = role.perms[level];
  if (perm === "all") return true;
  if (perm === "site") return siteCode !== undefined && user.sites.includes(siteCode);
  return false;
}

export function canRead(user: UserContext | null | undefined, siteCode?: string): boolean {
  return checkPerm(user, siteCode, "read");
}
export function canWrite(user: UserContext | null | undefined, siteCode?: string): boolean {
  return checkPerm(user, siteCode, "write");
}
export function canModify(user: UserContext | null | undefined, siteCode?: string): boolean {
  return checkPerm(user, siteCode, "modify");
}
export function isAdmin(user: UserContext | null | undefined): boolean {
  if (!user) return false;
  const role = ROLES[user.role];
  return !!role?.perms.admin;
}
